import ShareIcon from '@/assets/all-icons/share-icon';
import useTranslations from '@/i18n/useTranslations';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';

import './ArtGameHeader.css';

export default function ArtGameHeader({
  title,
  onBack,
  rightSlot = null,
  children = null,
  className = '',
  titleClassName = '',
  onShare = null,
  shareAriaLabel,
  backLabel,
}) {
  const t = useTranslations('common.newspaper.art_games.common');
  const resolvedShareAriaLabel = shareAriaLabel || t('share_game_aria');
  const resolvedBackLabel = backLabel || t('back_to_arcade_aria');

  return (
    <header className={`art-game-header ${className}`.trim()}>
      <div className="art-game-header__bar">
        <BackArrowIcon
          className="art-game-header__go-back"
          onClick={onBack}
          aria-label={resolvedBackLabel}
        />
        <h1 className={`art-game-header__title ${titleClassName}`.trim()}>{title}</h1>
        <div className="art-game-header__right">
          {rightSlot}
          {onShare ? (
            <button
              type="button"
              className="art-game-header__share"
              onClick={onShare}
              aria-label={resolvedShareAriaLabel}
            >
              <ShareIcon />
            </button>
          ) : null}
        </div>
      </div>
      {children}
    </header>
  );
}
